/* by-size-precut-sync.js — GENERATED from packages apps/dtfgo-gang-sheets/src/by-size/precut-sync by scripts/build-precut-sync-asset.ts. Do not edit in the theme. */
"use strict";
(() => {
  // src/by-size/precut-sync/plan.ts
  var BY_SIZE_PRINT_LINK = /\/f\/bs\/[^/?#]+$/;
  var text = (v) => typeof v === "string" && v !== "" ? v : null;
  function planPrecutSync(items) {
    var _a, _b, _c;
    const groups = /* @__PURE__ */ new Map();
    for (const item of items) {
      const link = text((_a = item.properties) == null ? void 0 : _a["_Print Ready File"]);
      if (!link || !BY_SIZE_PRINT_LINK.test(link)) continue;
      const g = (_b = groups.get(link)) != null ? _b : { pieces: 0, precut: [] };
      if (text((_c = item.properties) == null ? void 0 : _c["Pre-cut for"]) !== null) g.precut.push(item);
      else if (Number.isSafeInteger(item.quantity) && item.quantity > 0) g.pieces += item.quantity;
      groups.set(link, g);
    }
    const fixes = [];
    for (const g of groups.values()) {
      g.precut.forEach((line, i) => {
        const want = i === 0 ? g.pieces : 0;
        if (line.quantity !== want) fixes.push({ key: line.key, quantity: want });
      });
    }
    return fixes;
  }

  // src/by-size/precut-sync/runtime.ts
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var CART_PAGE = /\/cart\/?$/;
  var REQUEST_MS = 8e3;
  var WAIT_MS = 1e4;
  var MAX_PASSES = 5;
  var RELOAD_GUARD_MS = 6e4;
  var RELOAD_KEY = "by-size-precut-reload";
  function within(p, ms) {
    return new Promise((resolve, reject) => {
      const t = setTimeout(() => reject(new Error("timeout")), ms);
      p.then(
        (v) => (clearTimeout(t), resolve(v)),
        (e) => (clearTimeout(t), reject(e))
      );
    });
  }
  function installPrecutSync(win, opts) {
    var _a, _b, _c, _d;
    if (win.__bySizePrecutSync) return win.__bySizePrecutSync;
    const rawFetch = win.fetch.bind(win);
    const request = (url, init, read) => {
      const ac = typeof AbortController === "function" ? new AbortController() : null;
      const t = setTimeout(() => ac == null ? void 0 : ac.abort(), REQUEST_MS);
      return within(rawFetch(url, ac ? { ...init, signal: ac.signal } : init).then(read), REQUEST_MS).finally(() => clearTimeout(t));
    };
    const root = ((_c = (_b = (_a = win.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) != null ? _c : "/").replace(/\/?$/, "/");
    let running = null;
    let dirty = false;
    let checkoutWaiting = false;
    let bypass = false;
    const pass = async () => {
      const cart = await request(`${root}cart.js`, { credentials: "same-origin", headers: { accept: "application/json" } }, (res) => {
        if (!res.ok) throw new Error(`cart.js ${res.status}`);
        return res.json();
      });
      const fixes = planPrecutSync(Array.isArray(cart.items) ? cart.items : []);
      if (fixes.length === 0) return null;
      const updates = Object.fromEntries(fixes.map((f) => [f.key, f.quantity]));
      const init = { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json", accept: "application/json" }, body: JSON.stringify({ updates }) };
      const updated = await request(`${root}cart/update.js`, init, (done) => {
        if (!done.ok) throw new Error(`cart/update.js ${done.status}`);
        return done.json().catch(() => null);
      });
      if (!updated || !Array.isArray(updated.items) || planPrecutSync(updated.items).length > 0) throw new Error("pre-cut not satisfied");
      return { cart: updated, sig: JSON.stringify(fixes.map((f) => [f.key, f.quantity]).sort()) };
    };
    const pageSections = (all) => {
      var _a2, _b2, _c2, _d2;
      const byId = (id) => {
        var _a3, _b3, _c3;
        return (_c3 = (_b3 = (_a3 = win.document).getElementById) == null ? void 0 : _b3.call(_a3, id)) != null ? _c3 : null;
      };
      const wanted = [["cart-icon-bubble", "cart-icon-bubble", ".shopify-section"]];
      if (all) {
        wanted.push(
          ["main-cart-items", (_b2 = (_a2 = byId("main-cart-items")) == null ? void 0 : _a2.dataset) == null ? void 0 : _b2.id, ".js-contents"],
          ["main-cart-footer", (_d2 = (_c2 = byId("main-cart-footer")) == null ? void 0 : _c2.dataset) == null ? void 0 : _d2.id, ".js-contents"],
          ["cart-live-region-text", "cart-live-region-text", ".shopify-section"],
          ["CartDrawer", "cart-drawer", ".drawer__inner"]
        );
      }
      const out = [];
      for (const [id, section, selector] of wanted) {
        const el = byId(id);
        if (el && section) out.push({ el, section, selector });
      }
      return out;
    };
    const renderSections = async (all, cartData) => {
      var _a2, _b2, _c2, _d2, _e, _f, _g, _h, _i, _j;
      try {
        const targets = pageSections(all);
        if (targets.length === 0 || !win.DOMParser) return;
        const ids = targets.map((t) => encodeURIComponent(t.section)).join(",");
        const html = await request(`${win.location.pathname}?sections=${ids}`, { credentials: "same-origin", headers: { accept: "application/json" } }, (r) => {
          if (!r.ok) throw new Error(`sections ${r.status}`);
          return r.json();
        });
        for (const t of targets) {
          const src = html[t.section];
          const fresh = typeof src === "string" ? new win.DOMParser().parseFromString(src, "text/html").querySelector(t.selector) : null;
          if (fresh) ((_c2 = (_b2 = (_a2 = t.el).querySelector) == null ? void 0 : _b2.call(_a2, t.selector)) != null ? _c2 : t.el).innerHTML = fresh.innerHTML;
        }
        const count = cartData == null ? void 0 : cartData.item_count;
        if (all && typeof count === "number") {
          for (const el of [(_e = (_d2 = win.document).querySelector) == null ? void 0 : _e.call(_d2, "cart-items"), (_g = (_f = win.document).getElementById) == null ? void 0 : _g.call(_f, "main-cart-footer"), (_i = (_h = win.document).querySelector) == null ? void 0 : _i.call(_h, "cart-drawer")]) {
            (_j = el == null ? void 0 : el.classList) == null ? void 0 : _j.toggle("is-empty", count === 0);
          }
        }
      } catch {
      }
    };
    const lastReload = () => {
      var _a2, _b2, _c2;
      try {
        return (_c2 = JSON.parse((_b2 = (_a2 = win.sessionStorage) == null ? void 0 : _a2.getItem(RELOAD_KEY)) != null ? _b2 : "{}")) != null ? _c2 : {};
      } catch {
        return {};
      }
    };
    const refresh = (cartData, sig) => {
      var _a2;
      if (checkoutWaiting) return;
      let all = false;
      if (CART_PAGE.test(win.location.pathname) || typeof win.publish !== "function") {
        const last = lastReload();
        if (last.sig !== sig || !(Date.now() - Number(last.at) < RELOAD_GUARD_MS)) {
          try {
            (_a2 = win.sessionStorage) == null ? void 0 : _a2.setItem(RELOAD_KEY, JSON.stringify({ sig, at: Date.now() }));
          } catch {
          }
          win.location.reload();
          return;
        }
        all = true;
      }
      void renderSections(all, cartData);
      if (typeof win.publish !== "function") return;
      try {
        void Promise.resolve(win.publish("cart-update", { source: "by-size-precut-sync", cartData })).catch(() => void 0);
      } catch {
      }
    };
    const loop = async () => {
      let latest = null;
      try {
        for (let n = 0; dirty && n < MAX_PASSES; n++) {
          dirty = false;
          const updated = await pass();
          if (updated !== null) latest = updated;
        }
      } catch {
        dirty = false;
        latest = null;
      }
      if (latest !== null) refresh(latest.cart, latest.sig);
    };
    const sync = () => {
      dirty = true;
      running != null ? running : running = loop().finally(() => {
        running = null;
        if (dirty) void sync();
      });
      return running;
    };
    const writes = /* @__PURE__ */ new Set();
    const track = (p) => {
      const settled = within(p, WAIT_MS).then(
        () => void 0,
        () => void 0
      );
      writes.add(settled);
      void settled.finally(() => writes.delete(settled));
    };
    const busy = () => running !== null || writes.size > 0;
    const idle = async () => {
      while (busy()) {
        if (writes.size > 0) await Promise.all([...writes]);
        else if (running) await running;
      }
    };
    const urlOf = (input) => {
      try {
        const raw = typeof input === "string" ? input : input instanceof URL ? input.href : input == null ? void 0 : input.url;
        return raw ? new URL(raw, win.location.href).pathname : null;
      } catch {
        return null;
      }
    };
    win.fetch = ((input, init) => {
      const path = urlOf(input);
      const res = rawFetch(input, init);
      if (!path || !CART_WRITE.test(path)) return res;
      const done = res.then((r) => {
        if (r.ok) void sync();
      });
      track(done);
      return res;
    });
    const xhr = (_d = win.XMLHttpRequest) == null ? void 0 : _d.prototype;
    if (xhr) {
      const open = xhr.open;
      const send = xhr.send;
      const urls = /* @__PURE__ */ new WeakMap();
      xhr.open = function(method, url, ...rest) {
        urls.set(this, urlOf(url));
        return open.call(this, method, url, ...rest);
      };
      xhr.send = function(body) {
        const path = urls.get(this);
        if (path && CART_WRITE.test(path)) {
          track(
            new Promise((resolve) => {
              this.addEventListener("loadend", () => {
                if (this.status >= 200 && this.status < 300) void sync();
                resolve();
              });
            })
          );
        }
        return send.call(this, body);
      };
    }
    const waitThen = (e, go) => {
      if (bypass) {
        bypass = false;
        return;
      }
      if (!checkoutWaiting && !busy()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (checkoutWaiting) return;
      checkoutWaiting = true;
      const done = () => {
        checkoutWaiting = false;
        bypass = true;
        try {
          go();
        } finally {
          bypass = false;
        }
      };
      void within(idle(), WAIT_MS).then(done, done);
    };
    win.document.addEventListener(
      "submit",
      (e) => {
        var _a2;
        const form = e.target;
        const isCheckout = ((_a2 = e.submitter) == null ? void 0 : _a2.name) === "checkout" || typeof (form == null ? void 0 : form.action) === "string" && form.action.includes("/checkout");
        if (!form || !isCheckout) return;
        waitThen(e, () => {
          var _a3;
          return form.requestSubmit ? form.requestSubmit((_a3 = e.submitter) != null ? _a3 : void 0) : win.location.assign(`${root}checkout`);
        });
      },
      true
    );
    win.document.addEventListener(
      "click",
      (e) => {
        var _a2, _b2;
        const link = (_b2 = (_a2 = e.target) == null ? void 0 : _a2.closest) == null ? void 0 : _b2.call(_a2, 'a[href*="/checkout"]');
        if (!(link == null ? void 0 : link.href)) return;
        const href = link.href;
        waitThen(e, () => win.location.assign(href));
      },
      true
    );
    win.addEventListener("pageshow", (e) => {
      if (e.persisted) void sync();
    });
    if (opts.initialSync) void sync();
    return win.__bySizePrecutSync = { sync, idle };
  }

  // src/by-size/precut-sync/entry.ts
  var tag = document.getElementById("by-size-precut-sync");
  installPrecutSync(window, { initialSync: (tag == null ? void 0 : tag.getAttribute("data-in-cart")) === "true" });
})();
